import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Container,
  ListSubheader,
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Checkbox,
  ListItemText,
  TextField,
  InputAdornment,

} from '@mui/material';
import QuickSearchToolbar from './QuickSearchToolbar';
import './HasResults.css';
import _ from 'lodash';
import { useSelector } from 'react-redux'
import { getResults } from '../redux/actions'
import { useDispatch } from 'react-redux'
import Iconify from "./Iconify";
import classNames from 'classnames';
import html2canvas from 'html2canvas'
import ReactDOM from 'react-dom';

function HasResults2({ filteredStudies, filters, searchCriteria, searchCompleted }) {

  const [completeStudies, setCompleteStudies] = React.useState([])
  const [selected, setSelected] = React.useState("")

  const results = useSelector((state) => state.results)
  const resultsFetched = useSelector((state) => state.resultsFetched)

  const dispatch = useDispatch()

  React.useEffect(() => {
    const getResultsThunk = getResults()
    dispatch(getResultsThunk)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  React.useEffect(() => {
    //const completeStudies = results.map(v => ({ ...v, ...filteredStudies.find(sp => sp.id === v.nctid) }));
    if (results.length > 0) {
      setCompleteStudies(results.map(v => ({ ...v, ...filteredStudies.find(sp => sp.id === v.nctid) })))
      setSelected(results.filter(s => s.OutcomeMeasureUnitOfMeasure === "Participants" || s.OutcomeMeasureUnitOfMeasure === "percentage of participants")[0].OutcomeMeasureTitle)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results])

  const levenshteinDistance = (str1 = '', str2 = '') => {
    const track = Array(str2.length + 1).fill(null).map(() =>
      Array(str1.length + 1).fill(null));
    for (let i = 0; i <= str1.length; i += 1) {
      track[0][i] = i;
    }
    for (let j = 0; j <= str2.length; j += 1) {
      track[j][0] = j;
    }
    for (let j = 1; j <= str2.length; j += 1) {
      for (let i = 1; i <= str1.length; i += 1) {
        const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
        track[j][i] = Math.min(
          track[j][i - 1] + 1, // deletion
          track[j - 1][i] + 1, // insertion
          track[j - 1][i - 1] + indicator, // substitution
        );
      }
    }
    return track[str2.length][str1.length];
  };
  const onSelectionChange = (event, index) => {
    setSelected(event.target.value)
  }

  let responder = []
  let presented = []
  let endpoints = []
  let indications = []


  if (completeStudies.length > 0) {
    responder = completeStudies.filter(s => s.OutcomeMeasureUnitOfMeasure === "Participants" || s.OutcomeMeasureUnitOfMeasure === "percentage of participants" || s.OutcomeMeasureUnitOfMeasure === "Percentage of responders")
    presented = responder.filter(s => levenshteinDistance(selected, s.OutcomeMeasureTitle) < 10)

    //Endpoints
    endpoints = [...new Set(responder.map(study => study.OutcomeMeasureTitle))];
    //Indication
    indications = [...new Set(responder.map(study => study.condition[0]))];
  }


  let maxValue = 100;
  let ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]

  const maxValueItem = _.maxBy(presented, function (d) { return (d.OutcomeMeasureUnitOfMeasure === "percentage of participants" || d.OutcomeMeasureUnitOfMeasure === "Percentage of participants") ? d.OutcomeMeasurementValue : (d.OutcomeMeasurementValue / d.OutcomeDenomCountValue) * 100; });
  console.log(maxValueItem)

  if (maxValueItem) {
    maxValue = (maxValueItem.OutcomeMeasureUnitOfMeasure === "percentage of participants" || maxValueItem.OutcomeMeasureUnitOfMeasure === "Percentage of participants") ? maxValueItem.OutcomeMeasurementValue : (maxValueItem.OutcomeMeasurementValue / maxValueItem.OutcomeDenomCountValue) * 100;
  }

  console.log(maxValue)
  if (maxValue < 10) {
    maxValue = 10
    ticks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  }
  else if (maxValue >= 10 && maxValue < 50) {
    maxValue = 50
    ticks = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
  }

  const itemHeight = 70;

  const transformedSponsors = indications.map(item => {
    let _item = { id: item, title: item };

    let lvl = 0;
    const filtered = presented.filter(st => st.condition[0] === item);

    _item.treatments = [...new Set(presented.map(study => study.OutcomeGroupTitle))]

    const items = filtered.map((item, index) => {
      let parsed = { ...item, index: lvl };

      parsed.left = (item.OutcomeMeasureUnitOfMeasure === "percentage of participants" || item.OutcomeMeasureUnitOfMeasure === "Percentage of participants") ? item.OutcomeMeasurementValue : (item.OutcomeMeasurementValue / item.OutcomeDenomCountValue) * 100

      lvl++;
      return parsed;
    });
    _item.items = items;
    _item.rowHeight = lvl ? lvl * itemHeight + lvl * 20 : itemHeight + 20;

    return _item;
  });


  const ITEM_HEIGHT = 30;
  const ITEM_PADDING_TOP = 6;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 15 + ITEM_PADDING_TOP,
        width: 650,
      },
    },
  };

  console.log(completeStudies)
  console.log(transformedSponsors)
  console.log(maxValue, ticks)

  const saveAs = (uri, filename) => {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {

      link.href = uri;
      link.download = filename;

      //Firefox requires the link to be in the body
      document.body.appendChild(link);

      //simulate click
      link.click();

      //remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  }

  const downloadClicked = () => {

    const item = document.getElementsByClassName("graphs__content");
    const node = ReactDOM.findDOMNode(item[0]);
    const filename = searchCriteria["cond"] + ".png"
    // Get child nodes
    if (node instanceof HTMLElement) {
      html2canvas(node).then(function (canvas) {

        //setBase64img(canvas.toDataURL('image/png'))
        saveAs(canvas.toDataURL(), filename);
      });
    }
  }


  return (

    <Container maxWidth="xl">


      <FormControl sx={{ textAlign: "left" }}>
        <InputLabel id={"Endpoints"}>{"Endpoints"}</InputLabel>
        <Select
          id={"Endpoints"}
          /*multiple*/
          value={selected}
          onChange={onSelectionChange}
          input={<Input />}
          renderValue={(selected) => selected}
          MenuProps={MenuProps}
          /*onClose={() => setSearchText("")}*/
          sx={{
            textAlign: "left",
            width: "100%",
            height: 50,
            mb: 2
          }}
        >
          <ListSubheader>
            <TextField
              size="small"
              // Autofocus on textfield
              autoFocus
              placeholder={`Type to search. (${endpoints.length} items)`}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                  </InputAdornment>
                )
              }}
              /*onChange={(e) => setSearchText(e.target.value)}*/
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {endpoints.map((item, i) => (
            <MenuItem key={item + "_" + i} value={item} name={item} dense={true}>
              <Checkbox checked={(selected === item)} />
              <ListItemText primary={item} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Grid item xs={12}>
        <div className="graphs">
          <div className="graphs__content">
            <QuickSearchToolbar
              comp="EndpointResults"
              studiesCount={responder.length}
              filteredCount={responder.length}
              /*value={searchText}*/
              filters={filters}
              export={false}
              searchCriteria={searchCriteria}
              downloadClicked={() => downloadClicked()}
              /*onChange={(event) => requestSearch(event.target.value)}*/
              searchCompleted={resultsFetched}
            /*shareUrl={shareUrl}*/
            ></QuickSearchToolbar>
            <div className="graphs__timeline-graph">
              <span key={'time-tick-sponsor'} style={{
                width: 100 / (maxValue) + '%', top: "-20px", display: 'inline-block', textAlign: 'left', position: "absolute",
                left: 0 + "%", maxWidth: "8%", fontSize: "12px", color: "#333", fontWeight: "bold"
              }}>{"Indication"}</span>
              <span key={'time-tick-indication'} style={{
                width: 100 / (maxValue + 1) + '%', top: "-20px", display: 'inline-block', textAlign: 'left', position: "absolute",
                left: 8 + "%", maxWidth: "8%", fontSize: "12px", color: "#333", fontWeight: "bold"
              }}>{"Treatment"}</span>

              <div className="graphs__timeline-ticks-top">
                {ticks.map((item, index) => {
                  return (
                    <span key={'time-tick' + index} style={{
                      width: 100 / (maxValue) + '%', top: "-20px", display: 'inline-block', textAlign: index === 0 ? 'left' : index === ticks.length - 1 ? 'left' : 'left', position: "absolute",
                      left: (maxValue === 10) ? (item * 10) + "%" : (maxValue === 50) ? (item * 2) + "%" : item + "%"
                    }}>{item.toString()}</span>
                  );
                })}
              </div>

              <div className="graphs__timeline-now">
                {ticks.map((item, index) => {
                  return (
                    <div className="graphs__datenow-line" style={{ left: (maxValue === 10) ? (item * 10) + "%" : (maxValue === 50) ? (item * 2) + "%" : item + "%" }} />
                  );
                })}
              </div>

              <div className="graphs__timeline-graph-content">
                <div className="graphs__timeline-graph-studylist" >
                  {transformedSponsors.map((item, index) => {
                    return (<div
                      className="graphs__timeline-graph-studylist-sponsor"
                      key={'indication-' + index}
                      style={{
                        height: item.rowHeight + 'px',
                        paddingTop: "10px"
                      }}>
                      <div className="graphs__timeline-sponsor-label">{item.title}</div>
                      {item.items.map((itm, index) => {
                        return (
                          <div key={index} style={{ position: 'relative', zIndex: 3, paddingTop: "10px" }}>
                            {/*!getSponsorCondition(item.title, itm.condition) &&*/
                              <div
                                key={item.id + "condition"}
                                style={{
                                  height: itemHeight + "px",
                                  top: itm.index ? itm.index * itemHeight + "px" : "0",
                                  position: "absolute",
                                  textAlign: "left"
                                }}
                                className={classNames('graphs__study-timeline-condtion')}>
                                {itm.OutcomeGroupTitle}
                              </div>
                            }
                            {/*!getSponsorCondition(item.title, itm.condition) &&*/
                              <span style={{ position: "absolute", left: "0.5%", minHeight: "70px", height: itemHeight + "px", top: itm.index ? (itm.index * itemHeight) + 30 + "px" : "0" }} className={classNames("graphs__study-timeline-studyid")}>{itm.studyId.split("|")[0]}</span>
                            }
                            <a
                              rel="noreferrer"
                              key={itm.id}
                              href={"https://clinicaltrials.gov/ct2/results?cond=&term=" + itm.id + "&cntry=&state=&city=&dist=itm"}
                              target="_blank"
                              className={classNames("graphs__study-timeline-item")}
                              style={{
                                /*width: itm.itemWidth + "%",*/
                                height: "10px",
                                width: "10px",
                                borderRadius: "50%",
                                display: "inline-block",
                                /*height: itemHeight + "px",
                                minHeight: "70px",*/
                                top: itm.index ? itm.index * itemHeight + "px" : "0",
                                position: "absolute",
                                /*left: itm.left + "%",*/
                                font: "12px",
                                left: (maxValue === 10) ? (itm.left * 10) + "%" : (maxValue === 50) ? (itm.left * 2) + "%" : itm.left + "%",
                                backgroundColor: (itm.OutcomeGroupTitle.toLowerCase().includes("placebo")) ? "grey" : "blue"
                              }}
                            >
                            </a>
                            <span style={{
                              height: "10px",
                              width: "10px",
                              position: "absolute",
                              font: "10px",
                              top: itm.index ? (itm.index * itemHeight) + 12 + "px" : "0",
                              left: (maxValue === 10) ? (itm.left * 10) + "%" : (maxValue === 50) ? (itm.left * 2) + "%" : itm.left + "%",
                              color: (itm.OutcomeGroupTitle.toLowerCase().includes("placebo")) ? "grey" : "blue"
                            }}>
                              {Math.round(itm.left * 10) / 10}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    );
                  })}
                </div>
                <div className="graphs__timeline-ticks-bottom">
                  {ticks.map((item, index) => {
                    return (
                      <span key={'time-tick' + index} style={{
                        width: 100 / (maxValue) + '%', display: 'inline-block', textAlign: index === 0 ? 'left' : index === ticks.length - 1 ? 'left' : 'left', position: "absolute",
                        left: (maxValue === 10) ? (item * 10) + "%" : (maxValue === 50) ? (item * 2) + "%" : item + "%"
                      }}>{item.toString()}</span>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Grid >
    </Container>
  );
}

HasResults2.propTypes = {
  filteredStudies: PropTypes.array,
  studies: PropTypes.array,
  filters: PropTypes.object
};

export default HasResults2